function TrainingIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
      >
        <path
          d='M31 20C29.5 14.5 21.5 14 18.5 17.5C14 16 10 18.5001 10 18.5001C10 18.5001 10.5 12.0001 11.5 9.50002C13 9.33346 16.3 8.60033 17.5 7.00033C15.5 2.00019 11.5 2.99989 10.5 3.49989C9.5 3.99989 8 5.50033 7.5 9.00033C4 13.5003 2.5 18.5001 2 23.5003C9 29.5003 14 29.5 17.5 28.5C20 31 25.9388 30.9213 28.5 29.0003C30.5 27.5003 32 24.5 31 20Z'
          stroke='currentColor'
          fill='none'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </svg>
    </span>
  );
}

export default TrainingIcon;
